'use strict';

import { ExtensionState } from './extension-state';

ExtensionState.getInstance().connect();


